import * as React from 'react';
import { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FormComponent from './formComponent';
import shortid from 'shortid';
import { FavoritesService } from '../../services/FavoritesService';

class FormModalComponent extends Component {
    constructor(props) {
        super(props);
        // if this component is placed inside another modal, there will be a strange z-index issue, 
        // so we need to close the parent modal

        this.state = {
            modal: this.props.modal
        }

        this.btnId = 'toggle_' + shortid.generate();

        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        if (this.props.toggleButtonId != null) {

            let triggerElement = document.getElementById(this.props.toggleButtonId);

            if (triggerElement != null) {
                triggerElement.onclick = this.toggle;
            }
        }
    }

    toggle() {

        if (this.props.hideModal) {

            this.props.hideModal();

        } else {
            this.setState(prevState => ({
                modal: !prevState.modal
            }));
        }
    }

    //async getItemsInterestedIn(defaultValues) {
    //    console.log('defaultValues', defaultValues);

    //    if (!defaultValues)
    //        defaultValues = {};

    //    const favorites = await FavoritesService.list();
    //    if (favorites) {
    //        console.log('Favorites', favorites);
    //        defaultValues.itemsInterestedIn = '';
    //        favorites.value.items.map((favorite, key) => {
    //            console.log('Favorite', favorite);
    //            defaultValues.itemsInterestedIn += favorite.documentName + '<br />';
    //        });
    //        defaultValues.favItemCount = favorites.value.items.length;
    //    }

    //    return defaultValues;
    //}

    render() {

       // let buttonId = this.props.form.formName + '_modal';
        return (
            <div>
                {!this.props.hideModalToggleButton && <Button data-toggle={this.props.parentTargetModal ? 'modal' : ''}
                    data-target={this.props.parentTargetModal ? ('#' + this.props.parentTargetModal) : ''}
                    style={this.props.toggleButtonLabel && this.props.toggleButtonLabel !== "" ? {} : { display: 'none' }}
                    id={this.btnId} color="primary" onClick={() => {
                        this.toggle();
                    }}
                >
                    {this.props.toggleButtonLabel}
                </Button>}

                <Modal isOpen={this.state.modal || this.props.showModal}
                    toggle={this.toggle}
                    className={'modal-forms ' + (this.props.className || '')}
                    scrollable="true"
                    size="lg"
                >
                    <ModalHeader toggle={this.toggle}>
                        {this.props.headerSmallTitle && <div className="small-title" dangerouslySetInnerHTML={{ __html: this.props.headerSmallTitle }}></div>}
                        {this.props.headerTitle && <div className="title" dangerouslySetInnerHTML={{ __html: this.props.headerTitle }}></div>}
                    </ModalHeader>
                    <ModalBody>
                        <FormComponent
                            gooleRecaptchaSitekey={this.props.form.gooleRecaptchaSitekey}
                            apiEndpoint={this.props.form.apiEndpoint}
                            formName={this.props.form.formName}
                            defaultValues={this.props.form.defaultValues}
                            favItemCount={this.props.form.favItemCount}
                            culture={this.props.form.culture}
                            siteName={this.props.form.siteName}
                            showLabels={this.props.form.showLabels}
                            labelsOnTop={this.props.form.labelsOnTop}
                            inModal
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default FormModalComponent;